/* ==========================================================================
   HOLY LAND MARKET — HOMEPAGE JAVASCRIPT
   Handles: Hero Slideshow, Tabbed Collections, Smooth interactions
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- HERO SLIDESHOW ---------- */
  document.querySelectorAll('[data-hl-hero]').forEach(function(hero) {
    var track = hero.querySelector('[data-hl-track]');
    var slides = hero.querySelectorAll('[data-hl-slide]');
    var dots = hero.querySelectorAll('[data-hl-dot]');
    var prevBtn = hero.querySelector('[data-hl-prev]');
    var nextBtn = hero.querySelector('[data-hl-next]');
    var autoplaySpeed = parseInt(hero.getAttribute('data-hl-autoplay') || '4000', 10);
    var current = 0;
    var total = slides.length;
    var autoTimer = null;

    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (autoplaySpeed > 0) {
        autoTimer = setInterval(next, autoplaySpeed);
      }
    }
    function stopAutoplay() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAutoplay(); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); startAutoplay(); });
    });

    // Swipe support
    var touchStartX = 0;
    var touchEndX = 0;
    hero.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    hero.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
        startAutoplay();
      }
    }, { passive: true });

    // Pause on hover
    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });


  /* ---------- TABBED COLLECTIONS ---------- */
  document.querySelectorAll('[data-hl-tabs]').forEach(function(section) {
    var tabs = section.querySelectorAll('[data-hl-tab]');
    var panels = section.querySelectorAll('[data-hl-panel]');

    /*
     * Tab 1 is server-rendered. Tabs 2-18 ship as skeletons carrying a
     * data-hl-lazy-url and fetch their real cards the first time they are
     * opened, from /collections/<handle>?view=hl-tab (templates/collection.
     * hl-tab.liquid renders the cards only, with `layout none`).
     *
     * The panel is marked loaded up-front so a slow network cannot queue two
     * fetches for the same tab. On failure the attribute is restored so the
     * next click retries.
     */
    function loadPanel(panel) {
      var url = panel.getAttribute('data-hl-lazy-url');
      if (!url) return;

      panel.removeAttribute('data-hl-lazy-url');
      panel.removeAttribute('data-hl-load-failed');

      fetch(url, { credentials: 'same-origin' })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          var grid = panel.querySelector('.hl-product-grid');
          if (!grid) return;

          if (html.trim() === '') {
            // Collection resolved but has no products - drop the skeletons.
            grid.innerHTML = '';
            return;
          }

          grid.innerHTML = html;

          /*
           * No re-init needed for the variant pills: their handler is
           * delegated off document (see hl-best-sellers.liquid), so injected
           * cards work immediately. Images arrive loading="lazy" and the
           * panel is visible at this point, so they fetch right away.
           */
        })
        .catch(function(err) {
          // Restore so the next click retries, and hide the fake skeletons.
          panel.setAttribute('data-hl-lazy-url', url);
          panel.setAttribute('data-hl-load-failed', '');
          if (window.console) console.warn('[hl-tabs] could not load', url, err);
        });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-hl-tab');

        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function(p) {
          if (p.getAttribute('data-hl-panel') === target) {
            p.classList.add('is-active');
            loadPanel(p);
          } else {
            p.classList.remove('is-active');
          }
        });
      });

      /*
       * Warm the panel on hover/focus so the cards are usually already there
       * by the time the click lands. Harmless if it never fires (touch).
       */
      ['mouseenter', 'focus'].forEach(function(evt) {
        tab.addEventListener(evt, function() {
          var target = tab.getAttribute('data-hl-tab');
          panels.forEach(function(p) {
            if (p.getAttribute('data-hl-panel') === target) loadPanel(p);
          });
        }, { passive: true });
      });
    });

    // Keyboard accessibility
    tabs.forEach(function(tab, index) {
      tab.addEventListener('keydown', function(e) {
        var nextIndex;
        if (e.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        } else if (e.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        }
      });
    });
  });


  /* ---------- INTERSECTION OBSERVER (fade-in on scroll) ---------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hl-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.hl-animate').forEach(function(el) {
      observer.observe(el);
    });
  }

})();